import { type AiModelConfig } from '../api/aimodels/useAiModels';
import { useChatSidebarStore } from './useChatSidebarStore';
import { useModelSelectionStore } from './useModelSelectionStore';
import { useModelSelectorMenuStore } from './useModelSelectorMenuStore';

export type OpenAgentModelPickerParams = {
  model?: AiModelConfig;
  resourceId: string;
};

/**
 * Turns auto off and opens the chat sidebar with the model picker menu open. Selects `model` when
 * given; otherwise the selected model is left unchanged.
 */
export const openAgentModelPicker = ({ model, resourceId }: OpenAgentModelPickerParams) => {
  const { setIsAuto, setSelectedModel } = useModelSelectionStore.getState();

  setIsAuto(resourceId, false);

  if (model) {
    setSelectedModel(resourceId, model);
  }

  useChatSidebarStore.getState().setOpen(true);
  useModelSelectorMenuStore.getState().setOpen(resourceId, true);
};
